(function () {
  let analyticsStarted = false;
  let analyticsScheduled = false;

  const scheduleAnalytics = () => {
    if (analyticsScheduled || analyticsStarted) return;
    analyticsScheduled = true;

    const start = () => {
      analyticsScheduled = false;
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy?.analyticsProcessingAllowed() || analyticsStarted) return;
      analyticsStarted = true;

      if (!window.clarity) {
        (function (c, l, a, r, i, t, y) {
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
          t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "xjmtbztbfo");
      }

      window.clarity("consentv2", {
        ad_Storage: privacy.marketingAllowed() ? "granted" : "denied",
        analytics_Storage: "granted"
      });
    };

    const whenIdle = () => {
      if ("requestIdleCallback" in window) window.requestIdleCallback(start, { timeout: 2000 });
      else window.setTimeout(start, 0);
    };

    if (document.readyState === "complete") whenIdle();
    else window.addEventListener("load", whenIdle, { once: true });
  };

  const apply = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    if (privacy.analyticsProcessingAllowed()) scheduleAnalytics();
    if (typeof window.clarity === "function") {
      window.clarity("consentv2", {
        ad_Storage: privacy.marketingAllowed() ? "granted" : "denied",
        analytics_Storage: privacy.analyticsProcessingAllowed() ? "granted" : "denied"
      });
    }
  };

  document.addEventListener("visitorConsentCollected", apply);
  if (window.Shopify?.customerPrivacy) apply();
  else if (typeof window.Shopify?.loadFeatures === "function") {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => {
      if (!error) apply();
    });
  }
})();
